import { useHistory } from "react-router-dom";
import { Button, Row } from "antd";
import Title from "antd/lib/typography/Title";
import ActiveJobs from "./ActiveJobs/ActiveJobs";
import ExpiredJobs from "./ExpiredJobs/ExpiredJobs";

const Jobs = () => {
  const history = useHistory();
  return (
    <>
      <Title level={2}>Mine stillingsannonser</Title>
      <Row justify="end">
        <Button
          type="primary"
          size="large"
          onClick={() => history.push("/company/company-profile/jobs/create-job-posting/")}
        >
          Ny stillingsannonse
        </Button>
      </Row>
      <br />
      <br />
      <ActiveJobs />
      <br />
      <ExpiredJobs />
    </>
  );
};

export default Jobs;
